<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Mailiz</div>
        <div class="modal-body">

            <form *ngIf="formGroup && connectionStep === connectionStepTemplate.mailStep" [formGroup]="formGroup" (ngSubmit)="connectToMSSWithID()">
                <frg-form-input
                    label="Identifiant National PS"
                    [formGroup]="formGroup"
                    id="idnat"
                    [control]="formGroup.get('idnat')"
                    errorMessage="Identifiant National non valide"
                    required="true"
                ></frg-form-input>
                <frg-form-input
                    label="Mot de passe"
                    [formGroup]="formGroup"
                    id="password"
                    [control]="formGroup.get('password')"
                    errorMessage="Le mot de passe est obligatoire"
                    required="true"
                    type="password"
                ></frg-form-input>
                <div class="radiogroup-wrapper">
                  <div class="radiogroup-label">Type d'OTP*</div>
                  <div class="radios-wrapper">
                    <div class="radio-wrapper">
                      <input type="radio" id="otpMail" name="typeOTP" [formControl]="formGroup.get('typeOTP')" value="mail">
                      <label class="radio-label" for="otpMail">
                        <span class="label-wording">Mail</span>
                      </label>
                    </div>
                    <div class="radio-wrapper">
                      <input type="radio" id="otpSMS" name="typeOTP" [formControl]="formGroup.get('typeOTP')" value="sms">
                      <label class="radio-label" for="otpSMS">
                        <span class="label-wording">SMS</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="buttons-wrapper center">
                    <frg-button
                        [disabled]="!formGroup.valid"
                        type="submit"
                        fullWidth="true"
                    >Connexion
                    </frg-button>
                  </div>
                    <div class="buttons-wrapper center">
                    <frg-button 
                        [type]="'reset'" 
                        (activated)="closeModal()"
                        [backgroundColor]="'var(--darkest-primary)'"
                        fullWidth="true"
                    >Annuler
                    </frg-button>
                </div>
            </form>
            <form *ngIf="isOTPNeeded && formGroupOTP && connectionStep === connectionStepTemplate.otpStep" [formGroup]="formGroupOTP">
                <div class="otp-explain-wrapper">Un code de connexion temporaire (OTP) a été envoyé à l'adresse mail liée au compte Mailiz.<br>Consultez vos mails pour récupérer ce code et le renseigner ici.</div>
                <frg-form-input
                    label="OTP"
                    [formGroup]="formGroupOTP"
                    id="otp"
                    [control]="formGroupOTP.get('otp')"
                    errorMessage="OTP non valide"
                    required="true"
                ></frg-form-input>
                <div class="buttons-wrapper center">
                    <frg-button
                        (activated)="connectToMSSWithOTP()"
                        [disabled]="!formGroupOTP.valid"
                        fullWidth="true"
                    >Valider OTP</frg-button>
                </div>
                <frg-button 
                        [type]="'reset'" 
                        (activated)="closeModal()"
                        [backgroundColor]="'var(--darkest-primary)'"
                        fullWidth="true"
                    >Annuler
                    </frg-button>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>
